<template>
  <div class="userInfo">
    <img class="userInfo__image" :src="avatarUrl" alt="">
    <div class="userInfo__name"> {{userName}} </div>
  </div>
</template>

<script>
import {computed} from "vue";
import {useSettingsStore} from "@/store/settings";
import avatarFallback from "@/assets/img/Avatar.png";

export default {
  name: "UserInfo",
  setup() {
    const settingsStore = useSettingsStore();
    const userName = computed(() => {
      return settingsStore.user.user_name;
    })
    const avatarUrl = computed(() => settingsStore.user.img_url || avatarFallback);
    return {userName, avatarUrl}
  }
}
</script>


<style scoped lang="scss">
.userInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__image {
    width: 73px;
    height: 73px;
    border-radius: 100px;
  }
  &__name {
    color: var(--cd-highlight-text);
    font-weight: 400;
    font-size: 26px;
  }
}
</style>
